import { render, staticRenderFns } from "./index.vue?vue&type=template&id=0dcdf3fc&"
import script from "./index.vue?vue&type=script&lang=js&"
export * from "./index.vue?vue&type=script&lang=js&"
import style0 from "./index.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/myz/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0dcdf3fc')) {
      api.createRecord('0dcdf3fc', component.options)
    } else {
      api.reload('0dcdf3fc', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=0dcdf3fc&", function () {
      api.rerender('0dcdf3fc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/vue/web/index.vue"
export default component.exports